import React from 'react'

// Import common components
import { Box } from '../../common/Box'
import Icon from '../../common/Icon'

// Themes, assets
import { px2Rem } from '../../../themes/Mixins'
import ICONS from '../../../themes/Icon'

// Css
import './styles/Ideate.css'

const Ideate = ({ isAnimate, scale }) => {
  const pieces = [
    {
      url: ICONS.ideateBottom,
      class: '',
      style: {
        width: `calc(9px*${scale})`,
        height: `calc(5px*${scale})`,
        bottom: '0',
        left: '50%',
        transform: 'translateX(-50%)'
      }
    },
    {
      url: ICONS.bulb,
      class: 'bulb',
      style: {
        width: `calc(24px*${scale})`,
        height: `calc(28px*${scale})`,
        bottom: 'auto',
        left: '50%',
        top: '50%',
        transform: 'translateX(-50%) translateY(-50%)'
      }
    },
    {
      url: ICONS.ideateLeftBeam1,
      class: 'beam',
      style: {
        width: `calc(9px*${scale})`,
        height: `calc(3px*${scale})`,
        top: '50%',
        left: '0',
        transform: 'translateY(-50%)'
      }
    },
    {
      url: ICONS.ideateLeftBeam2,
      class: 'beam',
      style: {
        width: `calc(9px*${scale})`,
        height: `calc(7px*${scale})`,
        left: '10%',
        top: '10%'
      }
    },
    {
      url: ICONS.ideateCenterBeam,
      class: 'beam',
      style: {
        width: `calc(3px*${scale})`,
        height: `calc(9px*${scale})`,
        top: '-6%',
        left: '50%',
        transform: 'translateX(-50%)'
      }
    },
    {
      url: ICONS.ideateRightBeam1,
      class: 'beam',
      style: {
        width: `calc(9px*${scale})`,
        height: `calc(3px*${scale})`,
        top: '50%',
        right: '0',
        transform: 'translateY(-50%)'
      }
    },
    {
      url: ICONS.ideateRightBeam2,
      class: 'beam',
      style: {
        width: `calc(7px*${scale})`,
        height: `calc(9px*${scale})`,
        right: '10%',
        top: '10%'
      }
    }
  ]

  return (
    <Box customStyle={{
      width: `calc(${px2Rem(47)}*${scale})`,
      height: `calc(${px2Rem(47)}*${scale})`,
      marginBottom: scale === 1 ? `${px2Rem(10)}` : '',
      position: 'relative'
    }}>
      {
        pieces.map((icon, index) => {
          return (
            <Icon
              key={index}
              src={icon.url}
              className={isAnimate ? icon.class : ''}
              customStyle={{
                position: 'absolute',
                margin: '0',
                ...icon.style
              }}
            />
          )
        })
      }
    </Box>
  )
}

export default Ideate



// WEBPACK FOOTER //
// ./src/components/sections/process/Ideate.js